import { Box, Button, Text } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import type { FC } from 'react';
import Markdown from 'react-markdown';
import styles from './library-card-view-mode.module.css';

type LibraryCardViewModeProps = {
	description?: string;
	body: string;
	color: string;
};
export const LibraryCardViewMode: FC<LibraryCardViewModeProps> = ({
	color,
	description,
	body
}) => {
	const [isDescriptionView, { toggle }] = useDisclosure(true);

	return (
		<Box
			className={styles.container}
			style={{ '--type-color': color }}
			translate="no"
		>
			<Box
				className={styles.contentContainer}
				translate="no"
			>
				<Markdown>{isDescriptionView ? description : body}</Markdown>
			</Box>

			<Button
				className={styles.togglerContainer}
				onClick={toggle}
				variant="transparent"
			>
				<Text
					c={color}
					fw={500}
					fz="sm"
				>
					{isDescriptionView ? 'Description' : 'Body'}
				</Text>
			</Button>
		</Box>
	);
};
